export const ImageSmSize = {
  width: 50,
  height: 50,
};

export const ImageMdSize = {
  width: 125,
  height: 125,
};

export const ImageLgSize = {
  width: 190,
  height: 190,
};
